export enum PlayerState {
  PLAY = 'play',
  PAUSE = 'pause',
  STOP = 'stop',
  RESUME = 'resume',
  STARTED = 'started',
  PAUSED = 'paused',
}
